export default __webpack_public_path__ + "static/media/delete.fd9bf845.svg";